import './dashboard.scss'

export default function Header(props){

    return(
    <nav className="dash__header">
        <h1>Repair System</h1>
        <h1>Logged in as <span>{props.user}</span></h1>
    </nav>)
}